import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
	pauseModal: {
		position: 'fixed',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: 10000,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'auto',
		background: 'rgba(10, 12, 29, 0.75)',
	},
	pauseModalWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
		maxWidth: 800,
		width: 800,
		margin: 10,
		padding: 40,
		borderRadius: 24,
		backgroundColor: '#ffffff',
		color: '#283339',
	},
	pauseModalCloseBtn: {
		position: 'absolute',
		top: 12,
		right: 12,
		color: '#D0D0D0',
		fontSize: 25,
		fontWeight: 700,
		cursor: 'pointer',
	},
	pauseModalContent: {
		textAlign: 'center',
	},
	pauseModalImg: {
		width: 96,
	},
	pauseModalTitle: {
		fontSize: 28,
		fontWeight: 700,
		lineHeight: '40px',
		marginBottom: 16,
	},
	pauseModalDesc: {
		fontSize: 16,
		fontWeight: 500,
		lineHeight: '24px',
		marginBottom: 32,
	},
	pauseModalBtn: {
		cursor: 'pointer',
		fontSize: 18,
		fontWeight: 700,
		color: '#ffffff',
		background: '#ff8f00',
		borderRadius: 34,
		padding: '17px 55px',
		display: 'inline-block',
		textDecoration: 'none',
		'& svg': {
			marginBottom: '-1px',
			marginLeft: 10,
		}
	},
	'@media (max-width: 440px)': {
		pauseModalWrapper: {
			padding: '30px 20px',
		},
		pauseModalTitle: {
			fontSize: 25,
			lineHeight: '40px',
		},
		pauseModalBtn: {
			fontSize: 14,
			padding: '15px 30px',
		},
	},
}));